import React from 'react';
import {paths} from '../../common/dictionaries/urls';
import LocationForm from './location';
import WarehouseLocationsList from './allocations';
import LocationsAssignment from './locationsAssignment';
import LocationsUsageReport from './locationsUsageReport';

export const warehousesRoutes = [
  {
    'component': <WarehouseLocationsList />,
    'path': paths.WarehouseLocationsList,
  },
  {
    'component': <LocationForm />,
    'path': paths.LocationsForm,
  },
  {
    'component': <LocationsAssignment />,
    'path': paths.LocationsAssignment,
  },
  {
    'component': <LocationsUsageReport />,
    'path': paths.LocationsUsageReport,
  },
];
